import {required} from "vuelidate/lib/validators";

export class EuthanasiaReason {
    constructor(initObjectParams) {
        this.id = null;
        this.number = null
        this.name = null;
    }

    static get modelName() {
        return 'EuthanasiaReason'
    }

    static get validations() {
        return {
            number: { required },
            name: { required },
        }
    }

    static get validationFieldLabels() {
        return {
            number: 'Номер',
            name: 'Наименование',
        }
    }

    static get mapping() {
        return {}
    }

    static get label() {
        return 'Основание для эвтаназии'
    }

    label() {
        return 'Основание для эвтаназии'
    }

    static get newLabel() {
        return 'Новое основание для эвтаназии'
    }

    objectLabel() {
        return `${this.name}`
    }

    applyData(data) {
        this.id = data['id'];
        this.number = data['number'];
        this.name = data['name'];
    }

}